export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const UPDATE_DATA = (state, { id, data , value }) => {
  state[id][value] = data;
};

export const setList = (state, items) => {
  state.basketList = items;
};
export const openModal = state => {
  state.show = true;
};
export const hideModal = state => {
  state.show = false;
};
export const setItem = (state, item) => {
  state.singleItem = item;
};
export const setOfferPrice = (state, value) => {
  state.priceOffer = value;
};



// WEBPACK FOOTER //
// ./src/store/modules/basket/mutations.js